module.exports = __webpack_public_path__ + "assets/dripicons-v2.7e12564e72400735ae5b671780f6a9f7.eot";